import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import PrivateRoute from "components/PrivateRoute";

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/dashboard`}
          component={lazy(() => import(`./dashboard`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/lista-de-usuarios`}
          component={lazy(() => import("./user-list"))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/contas-a-pagar`}
          component={lazy(() => import(`./accounts-payable`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/contas-a-receber`}
          component={lazy(() => import(`./accounts-receivable`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/contas-a-pagar/nova-despesa`}
          component={lazy(() => import(`./accounts-payable/new-expense`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/contas-a-receber`}
          component={lazy(() => import(`./accounts-receivable`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/contas-a-receber/nova-receita`}
          component={lazy(() => import(`./accounts-receivable/new-revenue`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/ordens-de-servico`}
          component={lazy(() => import(`./service-orders`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/previsao-de-faturamento`}
          component={lazy(() => import(`./billing-reports/forecast`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/a-faturar`}
          component={lazy(() => import(`./billing-reports/ready`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/aprovacao-de-negociacoes`}
          component={lazy(() => import(`./negotiation-approvals`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/resumo-producao`}
          component={lazy(() => import(`./service-orders/production-summary`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/custodia-de-pagamento`}
          component={lazy(() => import(`./payment-custody`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/orcamentos`}
          component={lazy(() => import(`./commercial/quotes`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/plano-de-contas`}
          component={lazy(() => import(`./account-plan`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/relatorios`}
          component={lazy(() => import(`./reports`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/clientes`}
          component={lazy(() => import(`./customers`))}
        />
        <Route
          exact
          path={`${APP_PREFIX_PATH}/lista-de-clientes`}
          component={lazy(() => import(`./customers/list`))}
        />
        <Route
          exact
          path={`${APP_PREFIX_PATH}/novo-cliente`}
          component={lazy(() => import(`./customers/new-customer`))}
        />
        <Route
          exact
          path={`${APP_PREFIX_PATH}/detalhes-do-cliente/:uuid`}
          component={lazy(() => import(`./customers/details`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/empresas`}
          component={lazy(() => import(`./companies`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/empresas/nova-empresa`}
          component={lazy(() => import(`./companies/new-company`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/representantes`}
          component={lazy(() => import(`./dealers`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/representantes/novo-representante`}
          component={lazy(() => import(`./dealers/new-dealers`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/tabelas-de-preco`}
          component={lazy(() => import(`./pricing-tables`))}
        />
        <Redirect
          exact
          from={`${APP_PREFIX_PATH}`}
          to={`${APP_PREFIX_PATH}/dashboard`}
        />
      </Switch>
    </Suspense>
  );
};

export default React.memo(AppViews);
